import { Translations } from './translations';

const ptBR: Translations = {
  common: {
    about: 'Sobre',
    solutions: 'Soluções',
    otherServices: 'Serviços',
    contact: 'Contato',
    language: 'Idioma',
    learnMore: 'Saiba mais',
    address: 'Onde nos achar',
    letsChat: 'Vamos Conversar',
  },
  home: {
    intro: {
      title: 'Ficou sem bateria na estrada?',
      text: 'Evite surpresas, nosso sistema avisa antes da falha. Mais segurança, menos paradas e mais economia!',
      button: [{ title: 'Saiba Mais' }],
    },
    middleBlock: {
      title: 'Feito para qualquer estrada, qualquer veículo',
      text: 'Nosso sistema monitora suas baterias em tempo real e avisa antes da falha, evitando paradas e prejuízos.',
      button: 'Fale Conosco',
    },
    about: {
      title: 'Inteligente e Adaptativo',
      text: 'Monitoramento em tempo real da bateria com sensores e I.A., como um laboratório em miniatura dentro do seu veículo!',
      section: [
        { title: 'Investimento pequeno, mas com grande retorno!', content: 'Instalação rápida e fácil em qualquer veículo.', icon: '' },
        { title: 'Baixíssimo Consumo!', content: 'Funciona com pouca energia e não afeta o desempenho do veículo.', icon: '' },
      ],
    },
    contact: {
      title: 'Entre em Contato',
      text: 'Fale com a Vizage e conheça nossas soluções!',
    },
    devices: {
      title: 'Nossos Dispositivos',
      content: 'Conheça nossa linha completa de monitores de baterias.',
    },
    otherServices: {
      title: 'Confira outros serviços',
      subtitle: 'Soluções complementares para monitoramento, prevenção de falhas e gestão de sistemas críticos.',
      items: [
        {
          title: 'Monitoramento de Geradores',
          subtitle: 'Acompanhe baterias e condições críticas de geradores para reduzir falhas e paradas inesperadas.',
          icon: 'svg/generator.svg',
        },
        {
          title: 'Monitoramento de Nobreaks',
          subtitle: 'Supervisione baterias de nobreaks e identifique sinais de falha antes que afetem sua operação.',
          icon: 'svg/nobreak.svg',
        },
        {
          title: 'Monitoramento Externo Vizage',
          subtitle: 'Nossa equipe acompanha seus equipamentos, analisa alertas e ajuda na identificação preventiva de problemas.',
          icon: 'svg/monitoring.svg',
        },
      ],
    },
    supports: 'Apoios',
  },
  footer: {
    tellUsEverything: 'Conte-nos sobre suas necessidades',
    doYouHaveQuestion: 'Pronto para prevenir falhas de baterias? Vamos discutir suas necessidades de monitoramento.',
  },
  links: {
    title: 'Monitoramento que antecipa o futuro.',
    bio: 'Soluções inteligentes para acompanhar a saúde das suas baterias em tempo real.',
    items: {
      company: { label: 'Conheça a Vizage', description: 'Tecnologia para monitoramento inteligente de baterias' },
      whatsapp: { label: 'Fale com a nossa equipe', description: 'Tire suas dúvidas pelo WhatsApp' },
      email: { label: 'Envie um e-mail', description: 'Entre em contato com a equipe Vizage' },
      linkedin: { label: 'Siga a Vizage no LinkedIn', description: 'Novidades, projetos e bastidores' },
      instagram: { label: 'Acompanhe no Instagram', description: 'Conteúdo e atualizações da Vizage' },
    },
    socialLabels: {
      whatsapp: 'Vizage no WhatsApp',
      email: 'Enviar e-mail para a Vizage',
      linkedin: 'Vizage no LinkedIn',
      instagram: 'Vizage no Instagram',
    },
    footer: 'VIZAGE TECNOLOGIA LTDA',
  },
  devices: {
    vizageNode: 'Vizage Node',
    vizageMesh: 'Vizage Mesh',
    oneTimePayment: 'Pagamento único',
    localAlert: 'Alerta local',
    bluetoothConnection: 'Conexão Bluetooth',
    singleVehicle: 'Pode ser usado apenas em 1 veículo',
    findNearbyShops: 'Veja autoelétricas mais próximas de você',
    cloudAlert: 'Alerta em nuvem',
    wirelessCommunication: 'Comunicação sem fio',
    onlineManagement: 'Plataforma de gerenciamento online',
    unlimitedVehicles: 'Sem limite de veículos',
    personalizedSupport: 'Suporte personalizado',
  },
};

export default ptBR;
